import React, { useRef, useState } from "react";
import { Grid, Button, TextField, CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";

const CallingCardsDetail = () => {
  const [data, setData] = useState<any>(null);
  const [pin, setPin] = useState("");
  const [email, setEmail] = useState<string>("");
  const [cardNumber, setCardNumber] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [transactionId, setTransactionId] = useState<string>("");
  const [paypalInvoiceNumber, setPaypalInvoiceNumber] = useState<string>("");

  const [action, setAction] = useState<Boolean>(false);
  const agGridRef = useRef<AgGridReact | null>(null);

  const exportGridDataAsCSV = () => {
    if (agGridRef.current) {
      agGridRef.current.api.exportDataAsCsv();
    }
  };
  const columnDefs: ColDef[] = [
    {
      field: "firstname",
      headerName: "FirstName",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "email",
      headerName: "Email",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "PIN",
      headerName: "Pin",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "amount",
      headerName: "Amount",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "trnsaction_refference",
      headerName: "Transaction Reference",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "sold_date",
      headerName: "Sold Date",
      filter: true,
      resizable: true,
      sortable: true,
    },
  ];

  const onGridReady = (params: { api: { sizeColumnsToFit: () => void } }) => {
    params.api.sizeColumnsToFit();
  };

  const handleGetBundles = async () => {
    setData(null);
    toast.dismiss();
    if (
      pin.trim().length > 9 ||
      email.trim() !== "" ||
      cardNumber.trim() !== "" ||
      name.trim() !== "" ||
      transactionId.trim() !== "" ||
      paypalInvoiceNumber.trim() !== ""
    ) {
      setAction(true);
      requestBundles();
    } else {
      toast.error("Please enter valid input.");
    }
  };

  const requestBundles = async () => {
    await axiosInterceptorInstance
      .get(
        `/dashboard/CallingCardsAccountDetail?Pin=${pin.trim()}&Email=${email.trim()}&CardNumber=${cardNumber.trim()}&FirstName=${name.trim()}&TransactionId=${transactionId.trim()}&PaypalInvoiceNumber=${paypalInvoiceNumber.trim()}`
      )
      .then((res: any) => {
        setAction(false);
        const apiresponse = JSON.parse(res.data.body);
        if (apiresponse.Data?.length == 0 || apiresponse?.Data == null) {
          toast.error("Record not found.");
        } else {
          setData(apiresponse?.Data);
        }
      })
      .catch((error: any) => {
        setAction(false);
        toast.error(error.message);
      });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Calling Cards Details</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                className="formControl"
                label="Pin"
                variant="outlined"
                value={pin}
                onChange={(e) => setPin(e.target.value)}
                inputProps={{ maxLength: 20 }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                className="formControl"
                label="Email"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                inputProps={{ maxLength: 40 }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                className="formControl"
                label="CardNumber"
                variant="outlined"
                value={cardNumber}
                onChange={(e) => setCardNumber(e.target.value)}
                inputProps={{ maxLength: 100 }}
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                className="formControl"
                label="FirstName"
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                className="formControl"
                label="Transaction ID"
                variant="outlined"
                value={transactionId}
                onChange={(e) => setTransactionId(e.target.value)}
                inputProps={{ maxLength: 30 }}
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                className="formControl"
                label="PaypalInvoiceNumber"
                variant="outlined"
                value={paypalInvoiceNumber}
                onChange={(e) => setPaypalInvoiceNumber(e.target.value)}
                inputProps={{ maxLength: 20 }}
              />
            </Grid>
            <Grid item xs={4} margin="0 auto">
              {!action && (
                <Button
                  onClick={handleGetBundles}
                  className="dButton dButton2"
                  variant="contained"
                >
                  Search
                </Button>
              )}
              {action && (
                <Button className="dButton dButton2" variant="contained">
                  <CircularProgress color="inherit" size={30} />
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "5px",
        }}
      >
        <button
          className="small-btn"
          style={{ visibility: data ? "visible" : "hidden" }}
          onClick={() => {
            if (data) {
              exportGridDataAsCSV();
            }
          }}
        >
          Export as CSV
        </button>
      </div>
      {data && (
        <div className="ag-theme-alpine">
          <AgGridReact
            ref={agGridRef}
            paginationPageSize={12}
            pagination={true}
            domLayout="autoHeight"
            rowData={data}
            columnDefs={columnDefs}
            enableCellTextSelection={true}
            onGridReady={onGridReady}
          ></AgGridReact>
        </div>
      )}
    </motion.div>
  );
};

export default CallingCardsDetail;
